import { ClubInterviewState } from './state';
import * as actions from './actions';
import * as moment from 'moment';

export type Action = actions.All;
const defaultState = new ClubInterviewState();

export function ClubInterviewsReducer(state = defaultState, action: Action): ClubInterviewState {
    switch (action.type) {

        case actions.GET_CLUB_INTERVIEW_CLUB_EVENTS: {
            return {
                ...state,
                loading: true,
                filter: { matchRound: 1 },
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_CLUB_EVENTS_SUCCESS: {
            let clubItems = action.payload;
            return {
                ...state,
                clubItems,
                loading: false,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_DETAILS_FOR_CLUB: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_DETAILS_FOR_CLUB_SUCCESS: {
            return {
                ...state,
                detailsForClub: {
                    ...state.detailsForClub,
                    [action.matchId]: action.payload
                },
                loading: false,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_DETAILS_FOR_LEAGUE_BROADCASTER: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_DETAILS_FOR_LEAGUE_BROADCASTER_SUCCESS: {
            return {
                ...state,
                detailsForLeagueBroadcaster: {
                    ...state.detailsForLeagueBroadcaster,
                    [action.matchId]: action.payload
                },
                loading: false,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_LEAGUE_EVENTS: {
            return {
                ...state,
                filter: { matchRound: action.matchRound },
                loading: true
            };
        }

        case actions.GET_CLUB_INTERVIEW_LEAGUE_EVENTS_SUCCESS: {

            return {
                ...state,
                byGameWeek: { ...state.byGameWeek, [action.matchRound]: action.payload },
                loading: false,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_BROADCASTER_EVENTS: {
            return {
                ...state,
                loading: true,
                error: false,
                filter: { matchRound: action.matchRound },
            };
        }

        case actions.GET_CLUB_INTERVIEW_BROADCASTER_EVENTS_SUCCESS: {

            return {
                ...state,
                broadcasterByGameWeek: {
                    ...state.broadcasterByGameWeek,
                    [action.matchRound]: action.payload
                },
                loading: false,
                error: false
            };
        }

        case actions.CREATE_CLUB_INTERVIEW_EVENT: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.CREATE_CLUB_INTERVIEW_EVENT_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_EVENT: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_EVENT_SUCCESS: {
            const updatedDetailsForClub = state.detailsForClub[action.payload.matchId]
                ? {
                    ...state.detailsForClub,
                    [action.payload.matchId]: {
                        ...state.detailsForClub[action.payload.matchId],
                        event: action.payload
                    }
                }
                : { ...state.detailsForClub };

            let updatedDetailsForLeagueBroadcaster = { ...state.detailsForLeagueBroadcaster };

            if (state.detailsForLeagueBroadcaster[action.payload.matchId]) {
                const matchDetails = state.detailsForLeagueBroadcaster[action.payload.matchId];

                const updatedMatchDetails = { ...matchDetails };

                if (matchDetails.awayEvent &&
                    matchDetails.awayEvent.eventId === action.payload.eventId) {
                    updatedMatchDetails.awayEvent = action.payload;
                }
                
                if (matchDetails.homeEvent &&
                    matchDetails.homeEvent.eventId === action.payload.eventId) {
                    updatedMatchDetails.homeEvent = action.payload;
                }

                updatedDetailsForLeagueBroadcaster = {
                    ...updatedDetailsForLeagueBroadcaster,
                    [action.payload.matchId]: updatedMatchDetails
                };
            }

            return {
                ...state,
                detailsForClub: updatedDetailsForClub,
                detailsForLeagueBroadcaster: updatedDetailsForLeagueBroadcaster,
                loading: false,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_MATCH_INFO: {
            return {
                ...state,
                loading: true,
                selectedMatch: null,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_MATCH_INFO_SUCCESS: {
            return {
                ...state,
                loading: false,
                selectedMatch: action.payload,
                error: false
            };
        }

        case actions.CREATE_CLUB_INTERVIEW_REQUEST: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.CREATE_CLUB_INTERVIEW_REQUEST_SUCCESS: {
            // Early return if we don't have the required data
            if (!action.payload || !action.payload.matchId || !action.payload.eventId || !action.payload.requestDetails) {
                return {
                    ...state,
                    loading: false,
                    error: false
                };
            }

            const matchId = action.payload.matchId;
            const matchDetails = state.detailsForLeagueBroadcaster[matchId];



            if (!matchDetails ||
                (!(matchDetails.awayEvent?.eventId === action.payload.eventId)) ||
                (!(matchDetails.homeEvent?.eventId === action.payload.eventId))) {
                return {
                    ...state,
                    loading: false,
                    error: false
                };
            }

            const isAwayEvent = matchDetails.awayEvent && matchDetails.awayEvent.eventId === action.payload.eventId;
            const eventKey = isAwayEvent ? 'awayEvent' : 'homeEvent';
            const currentEvent = matchDetails[eventKey];

            const slotIndex = currentEvent.slots.findIndex(x => x.id === action.slotId);

            if (slotIndex === -1) {
                return {
                    ...state,
                    loading: false,
                    error: false
                };
            }

            const updatedMatchDetails = {
                ...matchDetails,
                [eventKey]: {
                    ...currentEvent,
                    requests: [...currentEvent.requests, action.payload.requestDetails[0]],
                    slots: currentEvent.slots.map((slot, index) =>
                        index === slotIndex
                            ? {
                                ...slot,
                                submittedRequests: [...slot.submittedRequests, action.payload.requestDetails[0].id]
                            }
                            : slot
                    )
                }
            }

            return {
                ...state,
                detailsForLeagueBroadcaster: {
                    ...state.detailsForLeagueBroadcaster,
                    [matchId]: updatedMatchDetails
                },
                loading: false,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_REQUEST: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_SUCCESS: {
            return {
                ...state,
                detailsForLeagueBroadcaster: {
                    ...state.detailsForLeagueBroadcaster,
                    [action.payload.matchId]: action.payload
                },
                loading: false,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_LEAGUE: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_LEAGUE_SUCCESS: {
            return {
                ...state,
                detailsForLeagueBroadcaster: {
                    ...state.detailsForLeagueBroadcaster,
                    [action.payload.matchId]: action.payload
                },
                loading: false,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_LEAGUE_NOTE: {
            return {
                ...state,
                loading: true,
                error: false
            };
        }

        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_LEAGUE_NOTE_SUCCESS: {
            return {
                ...state,
                detailsForLeagueBroadcaster: {
                    ...state.detailsForLeagueBroadcaster,
                    [action.payload.matchId]: action.payload
                },
                loading: false,
                error: false
            };
        }

        case actions.GET_CLUB_INTERVIEW_MATCH_INFO_ERROR:
        case actions.GET_CLUB_INTERVIEW_CLUB_EVENTS_ERROR:
        case actions.GET_CLUB_INTERVIEW_LEAGUE_EVENTS_ERROR:
        case actions.GET_CLUB_INTERVIEW_BROADCASTER_EVENTS_ERROR:
        case actions.CREATE_CLUB_INTERVIEW_EVENT_ERROR:
        case actions.UPDATE_CLUB_INTERVIEW_EVENT_ERROR:
        case actions.GET_CLUB_INTERVIEW_DETAILS_FOR_CLUB_ERROR:
        case actions.GET_CLUB_INTERVIEW_DETAILS_FOR_LEAGUE_BROADCASTER_ERROR:
        case actions.CREATE_CLUB_INTERVIEW_REQUEST_ERROR:
        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_ERROR:
        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_LEAGUE_ERROR:
        case actions.UPDATE_CLUB_INTERVIEW_REQUEST_LEAGUE_NOTE_ERROR: {
            return {
                ...state,
                loading: false,
                error: true
            };
        }
    }

    return state;
}
